import React from 'react'
import { ErrorBoundary } from '@sainsburys-tech/bolt'

import ShopSimilarIcon from '../../icons/ShopSimilarIcon'
import { scrollToAccordion } from '@/javascript/helpers/openAccordion'

import * as Styled from './ShopSimilarButton.styles'
import { pushEventAndTrack } from '../../../../helpers/taggingSerializer'

const SHOP_SIMILAR_SCROLL_TARGET_ID = 'shop-similar-scroll-target'

const ShopSimilarButton = ({ partNumber }) => {
  const handleClick = () => {
    const syteOrigin = 'image'
    pushEventAndTrack({
      eventInfo: {
        eventName: 'pdp_syteDiscoveryButtonClick',
        eventAction: 'PDP Syte Interaction - Discovery Button Click'
      },
      attributes: {
        productID: partNumber,
        syteOrigin
      }
    })

    const targetElement = document.getElementById(SHOP_SIMILAR_SCROLL_TARGET_ID)
    if (targetElement) {
      // Use same logic for scrolling to accordions for consistent offset behaviour (when the sticky nav bar is present)
      scrollToAccordion(`#${SHOP_SIMILAR_SCROLL_TARGET_ID}`)
    }
  }

  return (
    <ErrorBoundary>
      <Styled.ShopSimilarButton
        aria-label='Find similar products button'
        label='Find similar products'
        kind='secondary'
        onClick={handleClick}
      >
        <ShopSimilarIcon />
        <span>Shop similar</span>
      </Styled.ShopSimilarButton>
    </ErrorBoundary>
  )
}

export default ShopSimilarButton
